document.addEventListener('DOMContentLoaded', ()=>{
  const hook = setInterval(()=>{
    
    let hulkDiv = document.querySelector('div[id^="hulkapps_custom_options"]');
    // console.log("hook call", hulkDiv);
    if (hulkDiv && document.readyState === 'complete' && hulkapps || typeof hulkapps === 'undefined'){
      // console.log("hook call found ");
      clearInterval(hook);
      document.querySelector('.hulk-disable').classList.remove('hulk-disable');
    }
  },150)
    // setTimeout(()=>{
    //   clearInterval(hook);
    // },10000)
});


